import _ from 'lodash'
const PROFESIONAL_FORMS_CONFIG = {
    section: _.select( '.c-section--profesional-customers' ),
    togglers: _.selectAll( '.c-section--profesional-customers .toggler input' ),
    forms: _.selectAll( '.c-section--profesional-customers .forms .form__wrap' )
}

export default PROFESIONAL_FORMS_CONFIG